import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

export const adClickChannelChangeBeacon = (action) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.INTERACT,
  eventName: EVENT_NAMES.CHANNEL_CHANGE,
  label: `newChannelID=${action.payload.targetChannelId}|currentlyPlaying=ad`,
  utmSource: action.payload.utmSource,
  utmMedium: action.payload.utmMedium,
  utmCampaign: action.payload.utmCampaign,
  utmTerm: action.payload.utmTerm,
  utmContent: action.payload.utmContent,
});
